import { FC } from 'react';
import styled from 'styled-components';

import { CloseButton, StyledDialog } from '@/components/AlertDialogs/Dialog';
import Button from '@/components/Button';
import { Modal } from '@/components/Modal';
import Text from '@/components/Text';
import { VacationRequestType } from '@/utils/enums';

const Dialog = styled(StyledDialog)`
  display: flex;
  flex-direction: column;
  width: 464px;
  padding-bottom: 24px;
`;

const Heading = styled(Text)`
  margin-bottom: 16px;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: auto;
`;

const StyledButton = styled(Button)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  height: 75px;
  &:hover {
    border-color: ${({ theme }) => theme.colors.gray};
  }
`;

interface Props {
  onSelect: (type: VacationRequestType) => void;
  onClose: () => void;
}

const VacationTypeModal: FC<Props> = ({ onSelect, onClose }) => {
  return (
    <Modal>
      <Dialog
        initial={{ scale: 0.3 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0.3 }}
      >
        <CloseButton onClick={onClose}>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 1L1 13"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13 13L1 1"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </CloseButton>
        <Heading $type="heading2">Select vacation type:</Heading>
        <List>
          <StyledButton
            color="secondary"
            onClick={() => onSelect(VacationRequestType.Paid)}
          >
            Paid
            <Text as="span" $type="smallNormal" $color="gray">
              Deducted from your accrued balance
            </Text>
          </StyledButton>
          <StyledButton
            color="secondary"
            onClick={() => onSelect(VacationRequestType.Unpaid)}
          >
            Unpaid
            <Text as="span" $type="smallNormal" $color="gray">
              Time off without base compensation
            </Text>
          </StyledButton>
        </List>
      </Dialog>
    </Modal>
  );
};

export default VacationTypeModal;
